import script from "./tag-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./tag-list.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./tag-list.vue?vue&type=style&index=0&id=9b741fb6&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__